<div class="gc-dg-cards">
    <h3 class="gc-dg-text-2xl">Your order summary</h3>
    <p data-gc-dg-element="gc-dg-ach-discount-banner"
        class="gc-dg-font-semibold gc-dg-font-lg gc-dg-discount-details gc-dg-ach-price gc-dg-show-discount">
        You've
        <span class="gc-dg-discount-box gc-dg-py-1 gc-dg-px-2">saved <span class="gc-dg-discount"></span>%</span>
        by selecting ACH
    </p>
    <div id="gc-dg-appliances"></div>
    <div data-gc-dg-element="gc-dg-summary-total">
        <div class="gc-dg-text-xs gc-dg-ach-price gc-dg-show-discount">*The monthly rate of
            $<span class="gc-dg-net-first-payment-amount-after-promotion"></span> will apply when the promotional
            period ends.
        </div>
        <p class="gc-dg-d-inline gc-dg-font-semibold">Total</p>
        <p class="gc-dg-d-inline gc-dg-float-right gc-dg-font-semibold">
            $<span class="gc-dg-basket-monthly-total gc-dg-base-price"></span><span
                class="gc-dg-ach-basket-monthly-total gc-dg-ach-price"></span></span> per month
        </p>
    </div>
</div>